<template>
<div class="chapter">
<div class="inner_page">
<div class="appreciation" id="appreciation">
<div class="chapterHead">
<h2 class="chapterTitle-F">APPRECIATION</h2>
</div>
<p class="paraNoIndent">I am so glad to have the opportunity to say thank you to Tony for writing this splendid book. Among the many books written about the Vulcan this one is unique in describing so well, in mainly non technical terms, the birth pangs of the aircraft and the work it took to make it such an outstanding success.</p>
<p class="para">Not surprisingly, one of the things I really liked about this book was the fact that Tony realised that Roly not only tested the Vulcan but also sold it to the Royal Air Force, the politicians and above all, to the public, including the time he rolled the Vulcan for the first time at the Farnborough Air Display in 1955. Of course Tony has been able to write this account first hand because he was so intimately involved; Roly recruited Tony and he took over the Vulcan testing with Jimmy Harrison.</p>
<p class="para">The Spitfire is the aircraft icon of the Second World War and, thanks to Roly, Jimmy, Tony and RAF crews, the Vulcan is the aircraft icon of the Cold War. There are quite a few Spitfires still flying but to get a Vulcan flying again would be a magnificent achievement and this book will be a fitting backcloth to XH558 display flying again and will remind those who fly it, and those who watch, of the hard work that took place to make it all possible.</p>
<p class="para-Z">Leysa Falk</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VulcanTestPilot_appreciation.vue?6121c3ee